/*
  NOSH - FOUNDER FEEDBACK PASS 3: CUSTOMER CAPTURE (First name + Mobile) - 2026-10-01

  Shared by the 10% offer popup (sections/nosh-offer-popup.liquid) and the
  "Never miss a drop" block (sections/nosh-drop-alert.liquid). Both collect
  exactly the same two things, through this one file, so the data model cannot
  drift between them:

    first_name   -> Klaviyo profile first_name
    phone_number -> Klaviyo profile phone_number, always E.164 (+91XXXXXXXXXX)

  DESTINATION: Klaviyo (company TYbdZu, the account already installed on the
  store) through its public Client API, the same route the Notify-me back in
  stock feature already uses. One "Nosh Mobile Signup" event per submit, which
  creates or updates the profile and gives Klaviyo flows something to trigger on.
  The event carries the source ("popup_10" or "home_drop_block").

  HONESTY RULES
  - Success is shown ONLY when Klaviyo answers HTTP 200/202. Any other answer,
    a timeout or a blocked request shows an error and keeps what was typed.
  - Nothing here claims SMS, WhatsApp or email consent. The event records
    channel_consent = "not_asserted" plus the exact wording shown to the customer.
  - A honeypot field catches bots; they see a normal-looking thank-you and
    nothing is sent, so spam never reaches the profile list.

  MARKUP CONTRACT (all optional except the form, name and phone):
    <div data-nosh-capture-scope>
      <form data-nosh-capture data-source="..." data-offer="..." data-consent-note="..." novalidate>
        [data-nosh-capture-name] [data-nosh-capture-phone] [data-nosh-capture-hp]
        [data-nosh-capture-error="name|phone"]  [data-nosh-capture-status]  [data-nosh-capture-submit]
      </form>
      [data-nosh-capture-hide]   anything else to hide once the submit succeeds
      [data-nosh-capture-done] [data-nosh-capture-name-out] [data-nosh-capture-done-text]
    </div>
  data-autodone on the form shows the done state on load when the customer has
  already signed up on this device (used by the homepage block).
*/
(function () {
  'use strict';
  if (window.NoshCapture) return;

  var KLAVIYO_COMPANY = 'TYbdZu';
  var KLAVIYO_REVISION = '2024-10-15';
  var METRIC = 'Nosh Mobile Signup';
  var FORM_VERSION = 'ffp3-2026-10-01';
  var DONE_KEY = 'nosh_capture_done_v1';
  var TIMEOUT_MS = 12000;

  var MSG = {
    name: 'Please enter your first name.',
    phone: 'Enter a valid 10-digit mobile number.',
    network: "We couldn't save your details. Please check your connection and try again."
  };

  var memoryDone = null;

  function readDone() {
    try {
      var raw = window.localStorage.getItem(DONE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return memoryDone;
  }

  function writeDone(source) {
    var value = { t: Date.now(), source: source };
    memoryDone = value;
    try {
      window.localStorage.setItem(DONE_KEY, JSON.stringify(value));
    } catch (e) {}
  }

  function isDone() {
    return !!readDone();
  }

  /* Accepts 98765 43210, 098765 43210, 91 98765 43210, +91-98765-43210, 0091..., and a
     non-Indian number only when it is typed with a leading + or 00. Returns E.164. */
  function normalizePhone(raw) {
    var s = String(raw || '').trim();
    if (!s) return { ok: false, reason: 'empty' };
    var plus = s.charAt(0) === '+';
    var digits = s.replace(/\D/g, '');
    if (!plus && digits.indexOf('00') === 0) {
      plus = true;
      digits = digits.slice(2);
    }
    var national;
    if (plus) {
      if (digits.indexOf('91') !== 0) {
        if (digits.length >= 8 && digits.length <= 15) return { ok: true, e164: '+' + digits, national: '' };
        return { ok: false, reason: 'format' };
      }
      national = digits.slice(2);
    } else if (digits.length === 10) {
      national = digits;
    } else if (digits.length === 11 && digits.charAt(0) === '0') {
      national = digits.slice(1);
    } else if (digits.length === 12 && digits.indexOf('91') === 0) {
      national = digits.slice(2);
    } else {
      return { ok: false, reason: 'format' };
    }
    if (!/^[6-9]\d{9}$/.test(national)) return { ok: false, reason: 'format' };
    return { ok: true, e164: '+91' + national, national: national };
  }

  function validName(v) {
    if (!v || v.length > 60) return false;
    try {
      return new RegExp('\\p{L}', 'u').test(v);
    } catch (e) {
      return /[A-Za-z]/.test(v);
    }
  }

  function send(data) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            source: data.source,
            offer: data.offer,
            page_path: window.location.pathname,
            page_url: window.location.href.split('#')[0].slice(0, 500),
            channel_consent: 'not_asserted',
            consent_wording: data.consentNote,
            form_version: FORM_VERSION
          },
          metric: { data: { type: 'metric', attributes: { name: METRIC } } },
          profile: {
            data: {
              type: 'profile',
              attributes: { phone_number: data.e164, first_name: data.firstName }
            }
          }
        }
      }
    };
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, TIMEOUT_MS);
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(
      function (res) {
        clearTimeout(timer);
        if (res.status === 202 || res.status === 200) return true;
        var err = new Error('klaviyo_' + res.status);
        err.status = res.status;
        throw err;
      },
      function (err) {
        clearTimeout(timer);
        throw err;
      }
    );
  }

  function showDone(form, own, name) {
    var scope = form.closest('[data-nosh-capture-scope]') || form.parentNode;
    var hide = scope.querySelectorAll('[data-nosh-capture-hide]');
    if (hide.length) {
      for (var i = 0; i < hide.length; i++) hide[i].hidden = true;
    }
    form.hidden = true;
    var done = scope.querySelector('[data-nosh-capture-done]');
    if (!done) return;
    var out = done.querySelector('[data-nosh-capture-name-out]');
    if (out) out.textContent = name || '';
    var text = done.querySelector('[data-nosh-capture-done-text]');
    if (text && !own && done.getAttribute('data-already-text')) {
      text.textContent = done.getAttribute('data-already-text');
    }
    done.hidden = false;
    if (own) done.focus({ preventScroll: false });
  }

  function bind(form) {
    if (form.__noshCapture) return;
    form.__noshCapture = true;

    var nameEl = form.querySelector('[data-nosh-capture-name]');
    var phoneEl = form.querySelector('[data-nosh-capture-phone]');
    var submitEl = form.querySelector('[data-nosh-capture-submit]');
    var statusEl = form.querySelector('[data-nosh-capture-status]');
    var hpEl = form.querySelector('[data-nosh-capture-hp]');
    if (!nameEl || !phoneEl) return;

    var source = form.getAttribute('data-source') || 'unknown';
    var offer = form.getAttribute('data-offer') || '';
    var consentNote = form.getAttribute('data-consent-note') || '';
    var busy = false;

    function errorNode(key) {
      return form.querySelector('[data-nosh-capture-error="' + key + '"]');
    }

    function setError(input, key, message) {
      var node = errorNode(key);
      input.setAttribute('aria-invalid', 'true');
      if (node) {
        node.textContent = message;
        node.hidden = false;
      }
    }

    function clearError(input, key) {
      var node = errorNode(key);
      input.removeAttribute('aria-invalid');
      if (node) {
        node.textContent = '';
        node.hidden = true;
      }
    }

    function setStatus(message) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.hidden = !message;
    }

    function setBusy(on) {
      busy = on;
      form.setAttribute('aria-busy', on ? 'true' : 'false');
      if (submitEl) {
        submitEl.disabled = on;
        submitEl.classList.toggle('is-busy', on);
      }
    }

    nameEl.addEventListener('input', function () {
      clearError(nameEl, 'name');
      setStatus('');
    });
    phoneEl.addEventListener('input', function () {
      clearError(phoneEl, 'phone');
      setStatus('');
    });
    phoneEl.addEventListener('blur', function () {
      var p = normalizePhone(phoneEl.value);
      if (p.ok && p.national) phoneEl.value = p.national.slice(0, 5) + ' ' + p.national.slice(5);
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      setStatus('');
      clearError(nameEl, 'name');
      clearError(phoneEl, 'phone');

      var name = (nameEl.value || '').trim();
      var phone = normalizePhone(phoneEl.value);
      var first = null;
      if (!validName(name)) {
        setError(nameEl, 'name', MSG.name);
        first = first || nameEl;
      }
      if (!phone.ok) {
        setError(phoneEl, 'phone', MSG.phone);
        first = first || phoneEl;
      }
      if (first) {
        first.focus();
        return;
      }

      if (hpEl && hpEl.value) {
        showDone(form, true, name);
        return;
      }

      setBusy(true);
      send({
        source: source,
        offer: offer,
        consentNote: consentNote,
        e164: phone.e164,
        firstName: name
      }).then(
        function () {
          writeDone(source);
          setBusy(false);
          showDone(form, true, name);
          form.dispatchEvent(
            new CustomEvent('nosh:capture', { bubbles: true, detail: { source: source, name: name } })
          );
        },
        function () {
          setBusy(false);
          setStatus(MSG.network);
        }
      );
    });

    if (form.hasAttribute('data-nosh-capture-autodone') && isDone()) {
      showDone(form, false, '');
    }
  }

  function bindAll(root) {
    var forms = (root || document).querySelectorAll('form[data-nosh-capture]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  /* A signup in one place settles the other: the homepage block must not keep asking
     someone who has just joined through the popup. */
  document.addEventListener('nosh:capture', function (ev) {
    var forms = document.querySelectorAll('form[data-nosh-capture-autodone]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i] !== ev.target) showDone(forms[i], false, '');
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  else bindAll();
  document.addEventListener('shopify:section:load', function (ev) { bindAll(ev.target); });

  window.NoshCapture = { normalizePhone: normalizePhone, isDone: isDone, bind: bind, bindAll: bindAll };
})();